import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../components/Button';

const WorkProjectLinks = ({ slidesLink, videoHref, figmaLink, className }) => {
  if (!slidesLink && !videoHref && !figmaLink) {
    return null;
  }

  return (
    <div className={className}>
      <p className="work-side-nav__label">Project links</p>
      <div className="work-side-nav__project-links">
        {slidesLink && (
          <Button variant="link" href={slidesLink} className="work-side-nav__project-btn">
            Download PDF
          </Button>
        )}
        {videoHref && (
          <Button variant="link" href={videoHref} className="work-side-nav__project-btn">
            Video
          </Button>
        )}
        {figmaLink && (
          <Button variant="link" href={figmaLink} className="work-side-nav__project-btn">
            Figma prototype
          </Button>
        )}
      </div>
    </div>
  );
};

WorkProjectLinks.propTypes = {
  slidesLink: PropTypes.string,
  videoHref: PropTypes.string,
  figmaLink: PropTypes.string,
  className: PropTypes.string
};

WorkProjectLinks.defaultProps = {
  slidesLink: '',
  videoHref: '',
  figmaLink: '',
  className: ''
};

export default WorkProjectLinks;
